import React, { useMemo, useState } from 'react';
import { useLms } from '../../context/LmsContext';
import { CourseGradingSheet } from '../../components/GradingSheets';
import { Card, FormRow, PageHeader, StatusBadge } from '../../components/ui';
import { userIsCourseTrainer, trainerNames } from '../../utils/lmsSelectors';

export default function TrainerGrades() {
  const { data, currentUser } = useLms();
  const courses = useMemo(() => data.courses.filter((course) => currentUser.role === 'admin' || userIsCourseTrainer(data, course, currentUser.id)), [data, currentUser]);
  const [courseId, setCourseId] = useState(courses[0]?.id || '');
  const [query, setQuery] = useState('');
  const filteredCourses = courses.filter((course) => !query || `${course.title} ${course.category} ${course.status}`.toLowerCase().includes(query.trim().toLowerCase()));
  const selectedCourse = data.courses.find((course) => course.id === courseId) || filteredCourses[0];

  return (
    <>
      <PageHeader title="Course grading sheet" description="Review learner quiz and exercise grades for courses assigned to you as trainer." />
      <Card>
        <div className="form-grid">
          <FormRow label="Search course"><input className="search-input" placeholder="Search assigned course" value={query} onChange={(e) => setQuery(e.target.value)} /></FormRow>
          <FormRow label="Assigned course"><select value={selectedCourse?.id || ''} onChange={(e) => setCourseId(e.target.value)}>{filteredCourses.map((course) => <option key={course.id} value={course.id}>{course.title}</option>)}</select></FormRow>
        </div>
        {selectedCourse && (
          <div className="builder-topline">
            <StatusBadge status={selectedCourse.status} />
            <span>{selectedCourse.category}</span>
            <span>Trainer/s: {trainerNames(data, selectedCourse)}</span>
          </div>
        )}
      </Card>
      <Card>
        <h2>{selectedCourse?.title || 'No assigned course selected'}</h2>
        <CourseGradingSheet data={data} courseId={selectedCourse?.id || ''} onlyTrainerId={currentUser.id} />
      </Card>
    </>
  );
}
